import posthog from 'posthog-js';

type Properties = Record<string, any>;

export function track(name: string, properties?: Properties) {
  try {
    posthog.capture(name, properties);
  } catch (error) {
    // Fallback for when PostHog is not available or fails
    console.log('PostHog event (fallback):', name, properties);
    console.error('PostHog capture error:', error);
  }
}
